"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.teamsMembersMocks = exports.getTeamMembersListMock = void 0;

var _msw = require("msw");

var getTeamMembersListMock = _msw.rest.get('/api/v1/users/teammates-list', function (req, res, ctx) {
  return res(ctx.json({
    data: [{
      userId: 1324,
      userName: 'John Doe',
      teamId: 4321
    }, {
      userId: 1325,
      userName: 'Jane Doe',
      teamId: 4322
    }]
  }));
});

exports.getTeamMembersListMock = getTeamMembersListMock;
var teamsMembersMocks = [getTeamMembersListMock];
exports.teamsMembersMocks = teamsMembersMocks;